/**
 * system 模块（第 3 组）英文映射
 * 中文原文做 key，value 为英文译文；由 src/i18n/index.js 自动合并
 * 覆盖文件：src/views/system/modules/ 下 QuartzJobModal*、Role*、SelectUser*、
 * SysAnnouncement/SysCategory/SysCheckRule/SysDataSource/SysDepartRole/SysFillRule/
 * SysPosition/SysUserAgent、Tenant*、User*、area*、Icons、thawOrfreeze、userAreaAuth、userLogList
 */
export default {
  '${title}不能为空': '${title} cannot be empty',
  'Cron表达式': 'Cron Expression',
  'cron表达式': 'Cron Expression',
  '上传': 'Upload',
  '上级': 'Parent',
  '两次输入的密码不一样！': 'The two passwords do not match!',
  '中': 'Medium',
  '仅保存': 'Save Only',
  '代理人用户名': 'Agent Username',
  '代理开始时间': 'Agent Start Time',
  '代理结束时间': 'Agent End Time',
  '任务类名': 'Job Class Name',
  '优先级': 'Priority',
  '优先运行': 'Run First',
  '位数': 'Digits',
  '低': 'Low',
  '保存并关闭': 'Save and Close',
  '保存并安排任务': 'Save and Schedule Job',
  '全体用户': 'All Users',
  '全局规则': 'Global Rule',
  '全局规则可校验用户输入的所有字符；全局规则的优先级比局部规则的要高。': 'Global rules validate all characters entered by the user; global rules take precedence over partial rules.',
  '全部勾选': 'Check All',
  '共{total}条': 'Total {total} records',
  '内容': 'Content',
  '冻结': 'Freeze',
  '分类名称': 'Category Name',
  '功能测试': 'Function Test',
  '区域': 'Area',
  '区域分配': 'Area Assignment',
  '区域搜索': 'Area Search',
  '参数': 'Parameter',
  '取消全选': 'Uncheck All',
  '取消关联': 'Unlink',
  '取消选择': 'Deselect',
  '只能传递JSON对象，不能传递JSON数组': 'Only JSON objects are allowed, JSON arrays are not allowed',
  '合并所有': 'Collapse All',
  '品牌和标识': 'Brand and Logo',
  '头像': 'Avatar',
  '女': 'Female',
  '女性': 'Female',
  '姓名': 'Name',
  '密码由8位或8位以上数字、大小写字母和特殊符号组成!': 'Password must be at least 8 characters and contain digits, upper and lower case letters and special characters!',
  '尚未选择任何图标': 'No icon selected yet',
  '局部规则': 'Partial Rule',
  '局部规则按照你输入的位数有序的校验。': 'Partial rules validate character by character according to the digits you enter.',
  '展开': 'Expand',
  '展开所有': 'Expand All',
  '工号': 'Job Number',
  '工号已存在!': 'Job Number already exists!',
  '已选择': 'Selected',
  '座机': 'Landline',
  '开始时间': 'Start Time',
  '开始时间:': 'Start Time:',
  '开始时间需小于结束时间': 'Start time must be earlier than end time',
  '当前选择：': 'Currently selected:',
  '彻底删除': 'Delete Permanently',
  '彻底删除 {count} 个用户成功！': 'Permanently deleted {count} users successfully!',
  '彻底删除用户': 'Permanently Delete User',
  '性别': 'Gender',
  '恢复用户': 'Restore User',
  '您确定要彻底删除这 {count} 个用户吗？': 'Are you sure to permanently delete these {count} users?',
  '您确定要恢复这 {count} 个用户吗？': 'Are you sure to restore these {count} users?',
  '所拥有的权限': 'Owned Permissions',
  '手机号码': 'Mobile Phone',
  '批量删除': 'Batch Delete',
  '批量还原': 'Batch Restore',
  '指定用户': 'Specified Users',
  '指定用户不能为空！': 'Specified users cannot be empty!',
  '指示性图标': 'Suggestion Icons',
  '按钮权限': 'Button Permission',
  '描述': 'Description',
  '描述信息': 'Description',
  '提 交': 'Submit',
  '提交': 'Submit',
  '提示文本': 'Prompt Text',
  '搜索日志': 'Search Log',
  '摘要': 'Summary',
  '操作人ID': 'Operator ID',
  '操作人名称': 'Operator Name',
  '操作员': 'Operator',
  '操作日志': 'Operation Log',
  '操作类型': 'Operation Type',
  '收起': 'Collapse',
  '数据库名称': 'Database Name',
  '数据库类型': 'Database Type',
  '数据源名称': 'Data Source Name',
  '数据源地址': 'Data Source URL',
  '数据源编码': 'Data Source Code',
  '数据类图标': 'Data Icons',
  '数据规则': 'Data Rule',
  '数据规则/按钮权限配置': 'Data Rule/Button Permission Configuration',
  '方向性图标': 'Directional Icons',
  '无效': 'Invalid',
  '无配置信息!': 'No configuration!',
  '日志内容': 'Log Content',
  '日志类型': 'Log Type',
  '普通用户': 'Regular User',
  '最后运行': 'Run Last',
  '有效': 'Valid',
  '查询已删除的用户失败：': 'Failed to query deleted users: ',
  '标题': 'Title',
  '树操作': 'Tree Actions',
  '正常': 'Normal',
  '注意：彻底删除后将无法恢复，请谨慎操作！': 'Note: Data cannot be recovered after permanent deletion, please proceed with caution!',
  '测试': 'Test',
  '消息类型': 'Message Type',
  '添加已有用户': 'Add Existing User',
  '清空选择': 'Clear Selection',
  '点击保存': 'Click to Save',
  '点击选择区域': 'Click to select area',
  '点击选择部门': 'Click to select department',
  '父子关联': 'Parent-Child Link',
  '父级节点': 'Parent Node',
  '状态': 'Status',
  '生日': 'Birthday',
  '用户名': 'Username',
  '用户名不能包含中文！': 'Username cannot contain Chinese characters!',
  '用户名已存在!': 'Username already exists!',
  '用户名称': 'Customer Name',
  '用户回收站': 'User Recycle Bin',
  '用户姓名': 'Customer Name',
  '用户账号': 'User Account',
  '电话': 'Phone',
  '男': 'Male',
  '男性': 'Male',
  '登录密码': 'Login Password',
  '登录日志': 'Login Log',
  '确定放弃编辑？': 'Are you sure to discard the changes?',
  '确定要删除吗？': 'Are you sure to delete?',
  '确认密码': 'Confirm Password',
  '租户名称': 'Tenant Name',
  '租户编号': 'Tenant No.',
  '系统消息': 'System Message',
  '结束时间': 'End Time',
  '结束时间需大于开始时间': 'End time must be later than start time',
  '编码必须以字母开头，可包含数字、下划线、横杠': 'Code must start with a letter and may contain digits, underscores and hyphens',
  '编辑类图标': 'Edit Icons',
  '网站通用图标': 'Web Icons',
  '耗时(毫秒)': 'Elapsed Time (ms)',
  '职务': 'Position',
  '职务名称': 'Position Name',
  '职务编码': 'Position Code',
  '职级': 'Position Rank',
  '规则Code': 'Rule Code',
  '规则Code不能为空': 'Rule Code cannot be empty',
  '规则不能为空': 'Rule cannot be empty',
  '规则参数': 'Rule Parameter',
  '规则名称': 'Rule Name',
  '规则名称不能为空': 'Rule name cannot be empty',
  '规则实现类': 'Rule Implementation Class',
  '规则实现类不能为空': 'Rule implementation class cannot be empty',
  '规则描述': 'Rule Description',
  '规则（正则表达式）': 'Rule (Regular Expression)',
  '角色分配': 'Role Assignment',
  '角色名称': 'Role Name',
  '角色权限配置': 'Role Permission Configuration',
  '角色编码': 'Role Code',
  '角色编码不可输入汉字!': 'Role code cannot contain Chinese characters!',
  '解冻': 'Unfreeze',
  '该角色名称已存在!': 'This role name already exists!',
  '该角色编号已存在!': 'This role code already exists!',
  '请上传图片': 'Please upload an image',
  '请求参数:': 'Request Params:',
  '请求方法:': 'Request Method:',
  '请注意，现未勾选任何数据权限!': 'Note: no data permission is checked!',
  '请输入': 'Please enter',
  '请输入JSON字符串': 'Please enter a JSON string',
  '请输入cron表达式!': 'Please enter the cron expression!',
  '请输入代理人用户名': 'Please enter the agent username',
  '请输入代理人用户名!': 'Please enter the agent username!',
  '请输入代理开始时间!': 'Please enter the agent start time!',
  '请输入代理结束时间!': 'Please enter the agent end time!',
  '请输入任务类名': 'Please enter job class name',
  '请输入任务类名!': 'Please enter the job class name!',
  '请输入分类名称': 'Please enter the category name',
  '请输入区域名称': 'Please enter area name',
  '请输入参数': 'Please enter the parameter',
  '请输入密码': 'Please enter password',
  '请输入工号': 'Please enter the job number',
  '请输入座机': 'Please enter the landline number',
  '请输入手机号码': 'Please enter mobile phone number',
  '请输入描述': 'Please enter the description',
  '请输入描述信息': 'Please enter the description',
  '请输入搜索关键词': 'Please enter a search keyword',
  '请输入摘要': 'Please enter the summary',
  '请输入摘要!': 'Please enter the summary!',
  '请输入操作员': 'Please select the operator',
  '请输入数据库名称': 'Please enter the database name',
  '请输入数据库名称!': 'Please enter the database name!',
  '请输入数据源名称': 'Please enter data source name',
  '请输入数据源名称!': 'Please enter the data source name!',
  '请输入数据源地址': 'Please enter the data source URL',
  '请输入数据源地址!': 'Please enter the data source URL!',
  '请输入数据源编码': 'Please enter the data source code',
  '请输入数据源编码!': 'Please enter the data source code!',
  '请输入标题': 'Please enter the title',
  '请输入标题!': 'Please enter the title!',
  '请输入正确格式的手机号码!': 'Please enter a valid mobile phone number!',
  '请输入正确格式的邮箱!': 'Please enter a valid email address!',
  '请输入正确的座机号码': 'Please enter a valid landline number',
  '请输入正确的正则表达式': 'Please enter a valid regular expression',
  '请输入用户名': 'Please enter the username',
  '请输入用户名称!': 'Please enter the customer name!',
  '请输入用户姓名': 'Please enter customer name',
  '请输入用户账号': 'Please enter the user account',
  '请输入用户账号!': 'Please enter the user account!',
  '请输入登录密码': 'Please enter the login password',
  '请输入租户名称': 'Please enter the tenant name',
  '请输入租户编号': 'Please enter the tenant No.',
  '请输入类型名称!': 'Please enter the type name!',
  '请输入类型编码!': 'Please enter the type code!',
  '请输入职务名称': 'Please enter position name',
  '请输入职务编码': 'Please enter position code',
  '请输入规则Code': 'Please enter rule code',
  '请输入规则Code!': 'Please enter the rule code!',
  '请输入规则参数': 'Please enter the rule parameter',
  '请输入规则名称': 'Please enter rule name',
  '请输入规则名称!': 'Please enter the rule name!',
  '请输入规则实现类': 'Please enter the rule implementation class',
  '请输入规则描述': 'Please enter the rule description',
  '请输入角色名称': 'Please enter the role name',
  '请输入角色名称!': 'Please enter the role name!',
  '请输入角色编码': 'Please enter the role code',
  '请输入账号': 'Please enter the account',
  '请输入邮箱': 'Please enter the email',
  '请输入部门角色名称': 'Please enter the department role name',
  '请输入部门角色名称!': 'Please enter the department role name!',
  '请输入部门角色编码': 'Please enter the department role code',
  '请输入部门角色编码!': 'Please enter the department role code!',
  '请输入零以上的正整数': 'Please enter a positive integer',
  '请输入驱动类': 'Please enter the driver class',
  '请输入驱动类!': 'Please enter the driver class!',
  '请选择优先级': 'Please select priority',
  '请选择开始时间': 'Please select start time',
  '请选择开始时间!': 'Please select the start time!',
  '请选择性别': 'Select gender',
  '请选择性别查询': 'Select gender to query',
  '请选择操作类型': 'Please select operation type',
  '请选择数据库类型': 'Please select database type',
  '请选择数据库类型!': 'Please select the database type!',
  '请选择消息类型': 'Please select message type',
  '请选择消息类型!': 'Please select the message type!',
  '请选择父级节点': 'Please select the parent node',
  '请选择状态': 'Select status',
  '请选择生日': 'Please select the birthday',
  '请选择用户': 'Please select users',
  '请选择用户角色': 'Please select user roles',
  '请选择结束时间': 'Please select end time',
  '请选择结束时间!': 'Please select the end time!',
  '请选择职务': 'Please select the position',
  '请选择职级': 'Please select position rank',
  '请选择负责部门': 'Please select the departments in charge',
  '请选择通告对象类型!': 'Please select the announcement target type!',
  '请选择通告类型': 'Please select the announcement type',
  '请重新输入登录密码': 'Please re-enter the login password',
  '请重新输入登录密码!': 'Please re-enter the login password!',
  '负责部门': 'Departments in Charge',
  '账号': 'Account',
  '身份': 'Identity',
  '还原 {count} 个用户成功！': 'Restored {count} users successfully!',
  '还原用户': 'Restore User',
  '这是日志管理页面': 'This is the log management page',
  '连接中……': 'Connecting...',
  '连接失败': 'Connection Failed',
  '连接成功': 'Connection Succeeded',
  '选中 {name}': 'Selected {name}',
  '选择': 'Select',
  '选择用户': 'Select Customer',
  '通告类型': 'Announcement Type',
  '通知公告': 'Notice & Announcement',
  '邮箱': 'Email',
  '部门': 'Department',
  '部门分配': 'Department Assignment',
  '部门角色名称': 'Department Role Name',
  '部门角色编码': 'Department Role Code',
  '部门角色编码不可输入汉字!': 'Department role code cannot contain Chinese characters!',
  '长度不超过 126 个字符': 'No more than 126 characters',
  '长度不超过 64 个字符': 'No more than 64 characters',
  '长度在 2 到 30 个字符': 'Length must be between 2 and 30 characters',
  '项': 'items',
  '驱动类': 'Driver Class',
  '高': 'High',

  // ---- 系统账号（与用水客户区分） ----
  '账号名称': 'Account Name',
  '账号姓名': 'Account Holder Name',
  '账号状态': 'Account Status',
  '账号列表': 'Account List',
  '账号详情': 'Account Details',
  '账号信息': 'Account Information',
  '新增账号': 'Add Account',
  '编辑账号': 'Edit Account',
  '选择账号': 'Select Account',
  '已有账号': 'Existing Accounts',
  '冻结账号': 'Freeze Account',
  '解冻账号': 'Unfreeze Account',
  '账号回收站': 'Account Recycle Bin',
  '授权账号': 'Authorize Accounts',
  '登录账号': 'Login Account',
  '新建账号': 'Add Account',
  '请输入登录账号!': 'Please enter the login account!',
  '请输入账号名称!': 'Please enter the account name!'
}
